<template>
    <!-- Start Navbar -->
    <nav class="navbar navbar-expand-lg fixed-top custom-nav sticky">
        <div class="container">
            <!-- LOGO -->
            <a class="navbar-brand brand-logo mr-4" href="/">
                <img src="assets/images/logo.png" class="img-fluid logo-light resize-logo" alt="Merengón Bávaro® logo">
                <img src="assets/images/dark-logo.png" class="img-fluid logo-dark resize-logo" alt="Merengón Bávaro® logo">
            </a>

            <div class="navbar-collapse collapse justify-content-center" id="navbarCollapse">
                <ul class="navbar-nav navbar-center" id="mySidenav">
                    <!-- <li class="nav-item">
                        <router-link class="nav-link" to="/">Inicio</router-link>
                    </li> -->
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Productos
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                            <router-link class="dropdown-item" to="/postres">Postres</router-link>
                            <router-link class="dropdown-item" to="/bebidas">Bebidas</router-link>
                        </div>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/preguntas">Preguntas frecuentes</router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link class="nav-link" to="/contacto">Contacto</router-link>
                    </li> -->
                    <!-- <li class="nav-item">
                        <router-link class="nav-link" to="/roulette">Ruleta del sabor</router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link class="nav-link" to="/momentos-bavaros">Momentos Bávaros</router-link>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdownNosotros" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Nosotros
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownNosotros">
                            <router-link class="dropdown-item" to="/mision-vision">Misión y visión</router-link>
                            <router-link class="dropdown-item" to="/historia">Nuestra historia</router-link>
                        </div>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/blog">Blog</router-link>
                    </li>
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Pages
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                            <router-link class="dropdown-item" to="/error">404.</router-link>
                            <router-link class="dropdown-item" to="/blogdetail">Blog Detail.</router-link>
                            <router-link class="dropdown-item" to="/Login">Login.</router-link>
                            <router-link class="dropdown-item" to="/signup">Sign Up.</router-link>
                        </div>
                    </li> -->
                </ul>
                <div class="menu-close-btn"><i class="mdi mdi-close-circle-outline"></i></div>
            </div>
            <div class="header_btn">
                <div class="header-cta">
                    <router-link v-if="screenWidth >= 996" class="btn btn-hover btn-sm white-btn" to="/como-llegar">Cómo llegar<i class="mdi mdi-arrow-right ml-2"></i></router-link>
                    <router-link v-else class="btn btn-hover btn-sm white-btn" to="/como-llegar">Cómo llegar<i class="mdi ml-2"></i></router-link>
                    <a href="https://wa.me/+573185106016" target="_blank" rel="noopener" class="btn btn-hover btn-sm whatsapp-btn">
                        <i class="mdi mdi-whatsapp mr-2"></i>Haz tu pedido
                    </a>
                </div>
               <button class="navbar-toggler ml-2 p-0" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    <i class="mdi mdi-menu"></i>
                </button>
            </div>
        </div>
    </nav>
    <!-- End Navbar -->
</template>

<script>
    export default {
        name: "tomillo_header",
        data() {
            return {
                screenWidth: window.innerWidth
            }
        },
        mounted() {
            window.addEventListener('resize', this.updateScreenSize)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateScreenSize)
        },
        methods: {
            updateScreenSize() {
                this.screenWidth = window.innerWidth
            }
        }
    }
</script>
<style scoped>
    .resize-logo {
        height: 70px !important;
        width: auto !important;
        max-width: 100%;
        object-fit: contain;
    }

    .header_btn {
        display: flex;
        align-items: center;
        gap: 0.6rem;
    }

    .header-cta {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        flex-wrap: nowrap;
    }

    .whatsapp-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #25D366;
        color: #fff;
        font-weight: 600;
        padding: 0.55rem 1.4rem;
        border-radius: 50px;
        box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
        transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
        white-space: nowrap;
    }

    .whatsapp-btn i {
        font-size: 1.1rem;
    }

    .whatsapp-btn:hover,
    .whatsapp-btn:focus {
        background: #1ebe5b;
        color: #fff;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(37, 211, 102, 0.55);
        text-decoration: none;
    }

    @media (max-width: 991px) {
        .whatsapp-btn {
            padding: 0.5rem 1.1rem;
            font-size: 0.9rem;
        }
    }

    @media (max-width: 575px) {
        .resize-logo {
            height: 42px !important;
            width: auto !important;
        }

        .header_btn {
            flex-wrap: nowrap;
            gap: 0.3rem;
        }

        .header-cta {
            gap: 0.3rem;
        }

        .header-cta .btn {
            min-width: auto;
            height: auto;
            padding: 0.35rem 0.55rem;
            font-size: 0.65rem;
            white-space: nowrap;
        }

        .header-cta .btn i {
            font-size: 0.8rem;
            margin-left: 0.2rem !important;
            margin-right: 0.2rem !important;
        }

        .navbar-toggler {
            margin-left: 0.3rem !important;
        }
    }
</style>